/*eslint-disable */
import axios from "axios";
import * as types from "../types/shipmentTypes";
import {
  successAlertDispatcher,
  warningAlertDispatcher,
  errorAlertDispatcher,
  infoAlertDispatcher,
} from "./alertAction";
import ReadAxios from "../../components/axiosComponent/read";
const baseApi = process.env.REACT_APP_TA_API_URL;

/** Shipment region start */
export const createShipment = (shipment) => {
  return {
    type: types.SHIPMENT_CREATE,
    shipment,
  };
};

export const updateShipment = (shipment) => {
  return {
    type: types.SHIPMENT_UPDATE,
    shipment,
  };
};

export const readShipment = (shipments) => {
  return {
    type: types.SHIPMENT_READ,
    shipments,
  };
};

export const deleteShipment = (shipment) => {
  return {
    type: types.SHIPMENT_DELETE,
    shipment,
  };
};
/** Shipment region end */

/** Order region start */
export const createOrder = (order) => {
  return {
    type: types.ORDER_CREATE,
    order,
  };
};

export const updateOrder = (order) => {
  return {
    type: types.ORDER_UPDATE,
    order,
  };
};

export const deleteOrder = (order) => {
  return {
    type: types.ORDER_DELETE,
    order,
  };
};

export const readOrder = (order) => {
  return {
    type: types.ORDER_READ,
    order,
  };
};

export const deleteAllOrders = (order = []) => {
  return {
    type: types.ORDER_DELETE,
    order,
  };
};

/** Order region end */

/** Delivery region start */
export const createDelivery = (delivery) => {
  return {
    type: types.DELIVERY_CREATE,
    delivery,
  };
};

export const updateDelivery = (delivery) => {
  return {
    type: types.DELIVERY_UPDATE,
    delivery,
  };
};

export const deleteDelivery = (delivery) => {
  return {
    type: types.DELIVERY_DELETE,
    delivery,
  };
};

export const readDelivery = (delivery) => {
  return {
    type: types.DELIVERY_READ,
    delivery,
  };
};

/** Delivery region end */

/** Product region start */
export const createProduct = (product) => {
  return {
    type: types.PRODUCT_CREATE,
    product,
  };
};

export const updateProduct = (product) => {
  return {
    type: types.PRODUCT_UPDATE,
    product,
  };
};

export const deleteProduct = (product) => {
  return {
    type: types.PRODUCT_DELETE,
    product,
  };
};

export const readProduct = (product) => {
  return {
    type: types.PRODUCT_READ,
    product,
  };
};

/** Product region end */

// create new shipment action
export function createShipmentDispatcher(shipment, networkCall = false) {
  console.log('to store data', shipment);
  return (dispatch) => {
    dispatch(createShipment({ ...shipment }));
    return new Promise(function (resolve) {
      resolve({ ...shipment });
    });
  };
}

// read all shipment
export function readShipmentDispatcher() {
  return (dispatch) => {
    ReadAxios({ completeURL: `${baseApi}/shipments` })
      .then((res) => {
        dispatch(readShipment(res.data.shipments));
        return new Promise(function (resolve) {
          resolve(res.shipments);
        });
      })
      .catch((err) => {
        dispatch(readShipment([]));
        return new Promise(function (resolve) {
          resolve([]);
        });
      });
  };
}
// delete order by index
export function deleteOrderDispatcher(orderIndex) {
  return (dispatch, getState) => {
    const { create } = getState().shipment;
    create.orders.splice(orderIndex, 1);
    dispatch(createShipment({ ...create }));
    return new Promise(function (resolve) {
      resolve(create);
    });
  };
}

export function deleteAllOrderDispatcher() {
  return (dispatch, getState) => {
    const { create } = getState().shipment;
    create.orders = [];
    dispatch(createShipment({ ...create }));
    return new Promise(function (resolve) {
      resolve(create);
    });
  };
}

// discard shipment
export function discardShipmentDispatcher() {
  return (dispatch) => {
    // TODO: update the implementation
    dispatch(createShipment({}));
    return new Promise(function (resolve) {
      resolve({});
    });
  };
}

//read active orders

export const readActiveOrders = (shipments) => {
  return {
    type: types.SHIPMENT_READ,
    shipments,
  };
};

// read all active orders
export function readActiveOrdersDispatcher() {
  console.log("in active orders dispatcher")
  return (dispatch) => {
    let vendorId = localStorage.getItem("vendorId")
    ReadAxios({ completeURL: `${baseApi}/orders/broadcast/vendor/${vendorId}` })
      .then((res) => {
        dispatch(readActiveOrders(res.data.result
        ));
        return new Promise(function (resolve) {
          resolve(res.shipments);
        });
      })
      .catch((err) => {
        dispatch(readActiveOrders([]));
        return new Promise(function (resolve) {
          resolve([]);
        });
      });
  };
}

//read alloted orders

export const readAllotedOrders = (shipments) => {
  return {
    type: types.SHIPMENT_READ,
    shipments,
  };
};

// read all alloted orders
export function readAllotedOrdersDispatcher() {
  console.log("in active orders dispatcher")
  return (dispatch) => {
    let vendorId = localStorage.getItem("vendorId")
    ReadAxios({ completeURL: `${baseApi}/orders/vendor/${vendorId}` })
      .then((res) => {
        dispatch(readAllotedOrders(res.data.result
        ));
        return new Promise(function (resolve) {
          resolve(res.shipments);
        });
      })
      .catch((err) => {
        dispatch(readAllotedOrders([]));
        return new Promise(function (resolve) {
          resolve([]);
        });
      });
  };
}

//read vehicle reporting

export const readVehicleReporting = (shipments) => {
  console.log("In VR : ", shipments)
  return {
    type: types.SHIPMENT_READ,
    shipments,
  };
};

// read all vehicle reporting
export function readVehicleReportingDispatcher() {
  return (dispatch) => {
    let vendorId = localStorage.getItem("vendorId")
    ReadAxios({ completeURL: `${baseApi}/orders/vehicle/reporting/${vendorId}` })
      .then((res) => {
        dispatch(readVehicleReporting(res.data.data
        ));
        return new Promise(function (resolve) {
          resolve(res.data);
        });
      })
      .catch((err) => {
        dispatch(readVehicleReporting([]));
        return new Promise(function (resolve) {
          resolve([]);
        });
      });
  };
}